import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useChatBulkAuditResultsAdapterCard from './useChatBulkAuditResultsAdapterCard';
import { Filters } from '@scale/compass-ui/components/filters/Filters';
import { COLUMN_ID_TO_OPTIONS } from 'react-scale/corp/views/DataCompassCardsV2/components/filters/inputFilterOptions';
import { CHAT_BULK_AUDIT_RESULTS_INPUT_COLUMNS } from './constants';

const ChatBulkAuditResultsCardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const { filter, setFilter, auditBatchId, hasError } = useChatBulkAuditResultsAdapterCard(index);

  return (
    <>
      {!auditBatchId && filter ? (
        <>
          <div className="flex flex-col gap-4">
            <div>
              <em>Only Chat Bulk Audit audit batches can be queried with this adapter</em>
            </div>
          </div>
          <div className="flex flex-col gap-4 mt-4">
            <Filters
              columns={Object.values(CHAT_BULK_AUDIT_RESULTS_INPUT_COLUMNS)}
              filters={filter}
              setFilters={setFilter}
              columnOptionMap={COLUMN_ID_TO_OPTIONS}
              showErrors={hasError}
            />
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-4">
          <div>
            View and take action on your Chat Bulk Audit results with Compass. Hit "Run All" to
            refresh data.
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBulkAuditResultsCardComponent;
